// Shared by the navbar clock and the form page banner so both read the same.

/** Milliseconds until the form closes, never negative. */
export const remainingFrom = (locksAt) => {
  const at = locksAt ? new Date(locksAt).getTime() : 0;
  if (!at || Number.isNaN(at)) return 0;
  return Math.max(0, at - Date.now());
};

/**
 * "12d 04h 31m 12s", losing each leading segment as it reaches zero. Seconds
 * are always shown: a number that never moves reads as a stale page rather
 * than a live deadline.
 */
export const formatRemaining = (ms) => {
  const total = Math.max(0, Math.floor(ms / 1000));
  const days = Math.floor(total / 86400);
  const hours = Math.floor((total % 86400) / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  const seconds = total % 60;
  const pad = (n) => String(n).padStart(2, '0');

  const parts = [];
  if (days > 0) parts.push(`${days}d`);
  // Once a bigger segment is showing, the smaller ones cannot be skipped.
  if (parts.length || hours > 0) parts.push(`${pad(hours)}h`);
  if (parts.length || minutes > 0) parts.push(`${pad(minutes)}m`);
  parts.push(`${pad(seconds)}s`);
  return parts.join(' ');
};
